/**
 * Преобразует ссылку на изображение в элемент изображения.
 * 
 * Выполняет замену элемента в DOM.
 * 
 * @param link Элемент ссылки на изображение.
 */
function convertLinkToImage( link: HTMLAnchorElement ): void
{
	const parent = link.parentNode;
	const href = link.getAttribute( 'href' );
	
	if ( !parent || !href )
	{
		return;
	}
	
	const image = new Image();
	
	image.alt = link.textContent || '';
	image.src = href;
	
	parent.replaceChild( image, link );
}

/**
 * Module.
 */
export {
	convertLinkToImage as default,
};



// WEBPACK FOOTER //
// ./app/utils/convertLinkToImage.ts